import * as React from "react"

const SvgCamera = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M12 17.643q1.875 0 3.188-1.313 1.312-1.312 1.312-3.187t-1.313-3.188Q13.875 8.643 12 8.643T8.812 9.955Q7.5 11.268 7.5 13.143t1.313 3.187q1.311 1.313 3.187 1.313m0-2q-1.05 0-1.775-.725T9.5 13.143c0-1.05.242-1.292.725-1.775q.725-.725 1.775-.725c1.05 0 1.292.242 1.775.725q.725.725.725 1.775c0 1.05-.242 1.292-.725 1.775q-.725.725-1.775.725m-8 5.5q-.824 0-1.413-.588A1.93 1.93 0 0 1 2 19.143v-12q0-.825.587-1.413A1.93 1.93 0 0 1 4 5.143h3.15l1.25-1.35a2.01 2.01 0 0 1 1.475-.65h4.25q.425 0 .813.175t.662.475l1.25 1.35H20q.824 0 1.413.587.587.588.587 1.413v12q0 .825-.587 1.412a1.93 1.93 0 0 1-1.413.588zm0-2h16v-12h-4.05l-1.825-2h-4.25l-1.825 2H4z" />
  </svg>
)
export default SvgCamera
